import React, { Fragment } from "react";
import { CellRenderRowData, CellRenderOptions } from "./types/JobMatchDetailTypes";

/** custom cell render function used to render the aging/adj/geo/wgt default columns in JobMatchGridCreate */
export const JobMatchDefaultColumns = (rowData: CellRenderRowData, key: string, options: CellRenderOptions): JSX.Element => {
  const aging = rowData.aging_factor_default;
  const adj = rowData.data_adjustment_factor_default;
  const geo = rowData.geo_adj_factor_default;
  const wgt = rowData.data_weighting_factor_default;

  const standardizeDecimals = (num: number | null) => {
    return Number.isInteger(num)
      ? num
      : num?.toFixed(3);
  }

  const determineFactor = () => {
    return (
      key === 'aging-column'
        ? standardizeDecimals(aging)
      : key === 'adj-column'
        ? standardizeDecimals(adj)
      : key === 'geo-column'
        ? standardizeDecimals(geo)
      : key === 'wgt-column'
        ? standardizeDecimals(wgt)
      : null
    );
  };

  return (
    <Fragment>
      <div className="default-job-cell__title job-match">{determineFactor()}</div>
    </Fragment>
  );
};